import { pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';

import { atsProviderEnum } from './ats-configs';

import { candidates } from './candidates';
import { jobs } from './jobs';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';
import { users } from './users';
import { workflowStages } from './workflow-stages';

export const applications = pgTable(
  'applications',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    candidateId: uuid('candidate_id')
      .notNull()
      .references(() => candidates.id),
    jobId: uuid('job_id')
      .notNull()
      .references(() => jobs.id),
    atsExternalApplicationId: text('ats_external_application_id'),
    atsProvider: atsProviderEnum('ats_provider'),
    stageId: uuid('stage_id')
      .notNull()
      .references(() => workflowStages.id),
    createdById: uuid('created_by_id')
      .notNull()
      .references(() => users.id),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp('updated_at', { withTimezone: true })
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    unique('applications_candidate_job').on(t.candidateId, t.jobId),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
